import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal-precos-desatualizados',
  templateUrl: './modal-precos-desatualizados.component.html',
  standalone: true,
  styleUrls: ['./modal-precos-desatualizados.component.scss'],
  imports: [CommonModule, MatButtonModule, MatIconModule],
})
export class ModalPrecosDesatualizadosComponent implements OnInit {
    private router = inject(Router);
    private dialogRef = inject(MatDialogRef<ModalPrecosDesatualizadosComponent>);

  constructor() {

     setTimeout(() => {
        this.router.navigate(['/preco-combustivel']);
      }, 5000);
   }

  ngOnInit(): void {}

  fecharModal() {
      this.router.navigate(['/preco-combustivel']);
    this.dialogRef.close();

  }
}
